/*
* Here will be code required for i18n
* Just placeholder function for now
* */

function useDjangoGettext(text) { return window.gettext(text); }
function usePlaceholderFunction(text, options) {
    const applyParams = (string, params) => {
        let outString = string;
        if (params) {
            for (let index = 0; index < params.length; index++) {
                outString = outString.replace(new RegExp(`%(${(index + 1)}\\$)?[d@]`), params[index]);
            }
        }
        return outString;
    };
    const outerText = options ? applyParams(text, options) : text;
    return outerText;
}
const i18n = 'function' === typeof window.gettext ? useDjangoGettext : usePlaceholderFunction;
export default i18n;
